import React from 'react'
import { StyledStepper } from 'components'

const getSteps = (isAccountant = false) => [
  'contact info',
  'licensing',
  isAccountant ? 'business topic' : 'practice areas',
  'profile picture',
  'calendars',
  'advance settings',
]

const ProProfileCreationStepper = ({ activeStep, setActiveStep, isAccountant = false }) => {
  return <StyledStepper steps={getSteps(isAccountant)} activeStep={activeStep} setActiveStep={setActiveStep} />
}

export default ProProfileCreationStepper
